import sanitizeHTML from '../../../utils/sanitiseHTML';

const Quotes = ({ unsafeHtml }) => {
  return (
    <p className="section__quotes subtitle_1">
      &quot;{unsafeHtml}&quot;
    </p>
  );
};

export default Quotes;
